import React, {useEffect, useState} from 'react';

import {faCaretDown} from '@fortawesome/pro-solid-svg-icons';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import Filter from 'components/Filter/Filter';
import Icon from 'components/Icon/Icon';
import {useGlobalState} from 'hooks/useGlobalState';
import {useSetGlobalState} from 'hooks/useSetGlobalState';
import {setBeerFiltersAC} from 'store/beers/beerSlice';
import {getBeersACS} from 'store/beers/requestAC';
import {setShowFilterAC} from 'store/filter/filterSlice';
import {setCheckedBeerStyleAC} from 'store/singleBrewery/singleBrewerySlice';
import getBeerStylesFilterQuery from 'utils/helpers/getBeerStylesFilterQuery';
import {handleQueryDirection} from 'utils/helpers/handleQueryDirection';

export const BeersTableHead = () => {
  const dispatch = useSetGlobalState();

  const {filters} = useGlobalState((state) => state.beers);

  const [toggleDropdown, setToggleDropdown] = useState(false);

  useEffect(() => {
    dispatch(setShowFilterAC(toggleDropdown));
    // eslint-disable-next-line
  }, [toggleDropdown]);

  const handleSort = (column: 'name' | 'beer_style.name' | 'brewery.name' | 'brewery.country') => {
    const direction = handleQueryDirection(column, filters);
    dispatch(setBeerFiltersAC({...filters, column, direction}));
  };

  const handleFilter = (payload: string[]) => {
    if (payload.length > 0) {
      const filterQuery = getBeerStylesFilterQuery(payload);

      dispatch(getBeersACS({...filters, beerStyles: filterQuery}));
    } else {
      delete filters.beerStyleId;
      dispatch(getBeersACS({...filters}));
    }
  };

  const handleClearFilter = () => {
    dispatch(setCheckedBeerStyleAC([]));
    dispatch(getBeersACS({...filters, beerStyles: ''}));
  };

  return (
    <div className="beers-table__head">
      <div className="beers-table-head__cell">
        <span>Beer Name</span>
        <button className="beers-table-head__sort" onClick={() => handleSort('name')}>
          <Icon icon="sort-2" />
        </button>
      </div>
      <div className="beers-table-head__cell">
        <span>Brewery</span>
        <button className="beers-table-head__sort" onClick={() => handleSort('brewery.name')}>
          <Icon icon="sort-2" />
        </button>
      </div>
      <div className="beers-table-head__cell">
        <span>Style</span>
        <button className="beers-table-head__filter" onClick={() => setToggleDropdown((state) => !state)}>
          <FontAwesomeIcon icon={faCaretDown} />
        </button>
        <div className="beers-table-head__filter-wrapper">
          <Filter onFilter={handleFilter} onClear={handleClearFilter} />
        </div>
      </div>
      <div className="beers-table-head__cell">
        <span>Country</span>
        <button className="beers-table-head__sort" onClick={() => handleSort('brewery.country')}>
          <Icon icon="sort-2" />
        </button>
      </div>
      <div className="beers-table-head__cell">
        <span>ABV</span>
      </div>
      <div className="beers-table-head__cell">
        <span>IBU</span>
      </div>
      <div className="beers-table-head__cell-empty"> </div>
    </div>
  );
};
